/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';
import { setField } from '../helpers/savedSearches';

export const update = createAction('savedSearches/update', (id, data) => ({
  /** data is an object containing keys 'field' and 'value' to update */
  payload: { id, ...data },
}));

export const reducer = (builder) => {
  builder.addCase(
    update,
    (state, { payload: { id, field, value } }) => {
      state.tree = setField(state.tree, id, field, value);
    },
  );
};
